module.exports = __webpack_public_path__ + "fonts/NotoSansDisplay-SemiCondensedLightItalic.b541af1f.ttf";